import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { DialogModule } from '@angular/cdk/dialog';

const angularMaterial = [
  MatAutocompleteModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatIconModule,
  MatInputModule,
  MatTooltipModule,
  DialogModule,
  MatExpansionModule,
];
@NgModule({
  imports: [...angularMaterial],
  exports: [...angularMaterial],
  declarations: [],
  providers: [],
})
export class AngularMaterialModule {}
